import React from 'react';
import  {jQuery, Component} from './Helpers';
import Content from './Content';
import Context from './Context';
import './App.css';
import stickybits from 'stickybits';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      demographic: 'all',
      indicator: 'unemployment-rate',
      width: window.innerWidth
    };
    this.fetch();
  }

  async fetch() {
    const response = await fetch(`${window.siteURL}/wp-json/prc-api/v2/interactive?slug=economic-recoveries`);
    const data = await response.json();
    this.setState({data: data});
  }

  handleStep = (e) => {
    if (+e.detail == this.state.step || +e.detail === 0 || +e.detail === 4) return;
    this.setState({ step: +e.detail});
  }

  resize = (e) => {
    this.setState({width: window.innerWidth});
  }

  set_indicator = (e,d) => {
    this.setState({ indicator: d.name});
  }

  set_demographic = (e,d) => {
    this.setState({ demographic: d.name});
  }

  componentDidMount() {
    jQuery('article section').visibility({
      once: false,
      observeChanges: true,
      initialCheck: true,
      checkOnRefresh: true,
      refreshOnResize: true,
      continuous: true,
      onTopVisible: function(e) { window.dispatchEvent(new CustomEvent('step', {detail:+this.dataset.step}))}
      }
    );
    window.addEventListener('step', this.handleStep);
    window.addEventListener('resize', this.resize);
    if (typeof window.CSS === 'undefined' || !window.CSS.supports('(position : sticky) or (position: -webkit-sticky)')) {
      stickybits('.graphic.sticky',{stickyBitStickyOffset: window.innerHeight/2});
    }
    const subtitle = document.createElement('h2');
    subtitle.innerText = 'Compare the two longest episodes in U.S. history with our interactive';
    document.querySelector('.entry-header').append(subtitle);
  }

  render()  {
    return (
      <Context.Provider value={{...this.state, set_indicator: this.set_indicator, set_demographic: this.set_demographic}}>
        <Content />
      </Context.Provider>
    );
  }
}

export default App;
